export default "__VITE_ASSET__DDW1A2Ip__"